import { Action, ActionCreator } from '@ngrx/store';
import { ImportExcelDialogComponent } from './components/import-excel-dialog/import-excel-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ImportObjectTypes } from '../../da-engineer/screening/screening.constants';

export function openSpreadsheetDialog(
  dialog: MatDialog,
  importObjectType: ImportObjectTypes,
  onSuccessStoreAction: ActionCreator<string, () => Action<string>> | null
) {
  return dialog.open(ImportExcelDialogComponent, {
    panelClass: 'import-excel-dialog-config',
    closeOnNavigation: false,
    disableClose: true,
    maxWidth: 'unset',
    data: { importObjectType, onSuccessStoreAction },
  });
}